import { render } from "./ReporteVentas.vue?vue&type=template&id=15390190&scoped=true"
import script from "./ReporteVentas.vue?vue&type=script&lang=js"
export * from "./ReporteVentas.vue?vue&type=script&lang=js"

import "./ReporteVentas.vue?vue&type=style&index=0&id=15390190&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15390190"]])

export default __exports__